import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { RootComponent } from './app/components/root/root.component';
import { Config } from './modules/app-template/models/config.model';

Error.stackTraceLimit = 100;
if (Config.get().production) {
    enableProdMode();
}

bootstrapApplication(RootComponent, {
  providers: [
    importProvidersFrom(AppModule),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
  ],
}).catch(err => console.error(err));